import { useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { toast } from "react-toastify";
import MeuUsuarioService from "../../services/resource/meuUsuarioService";

const service = new MeuUsuarioService();

export default function PreferenciasNotificacaoCard({ perfil, onSalvo }) {
    const [receberEmailFinalizada, setReceberEmailFinalizada] = useState(!!perfil?.receberEmailSolicitacaoFinalizada);
    const [receberEmailNovaSolicitacao, setReceberEmailNovaSolicitacao] = useState(!!perfil?.receberEmailNovaSolicitacao);
    const [receberEmailAtrasadas, setReceberEmailAtrasadas] = useState(!!perfil?.receberEmailSolicitacaoAtrasadas);
    const [salvando, setSalvando] = useState(false);

    function alternar(campo, valorAtual, setValor, valor) {
        setValor(valor);
        setSalvando(true);
        service.atualizarPreferencias({
            receberEmailSolicitacaoFinalizada: receberEmailFinalizada,
            receberEmailSolicitacaoAtrasadas: receberEmailAtrasadas,
            receberEmailNovaSolicitacao: receberEmailNovaSolicitacao,
            [campo]: valor,
        })
            .then(() => {
                toast.success("Preferência atualizada!");
                onSalvo?.();
            })
            .catch(error => {
                console.error("Erro ao atualizar preferências", error);
                toast.error("Erro ao atualizar preferência");
                setValor(valorAtual);
            })
            .finally(() => setSalvando(false));
    }

    return (
        <div className="flex flex-col gap-4 pt-2 max-w-2xl">
            <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide">Preferências de Notificações</h3>

            <div className="flex items-center justify-between gap-4 p-4 border border-border rounded-lg bg-muted/30">
                <div className="flex items-start gap-3">
                    <i className="fa fa-bell text-primary mt-1" />
                    <div>
                        <div className="font-medium text-foreground">Notificações no sistema</div>
                        <p className="text-sm text-muted-foreground">
                            Você sempre recebe uma notificação no sino do MyDash quando uma tarefa é atribuída a você
                            ou ao seu grupo, e quando uma solicitação sua é finalizada.
                        </p>
                    </div>
                </div>
                <span className="text-xs font-semibold uppercase tracking-wide text-success shrink-0">Sempre ativo</span>
            </div>

            <div className="flex items-center justify-between gap-4 p-4 border border-border rounded-lg">
                <div className="flex items-start gap-3">
                    <i className="fa fa-envelope text-primary mt-1" />
                    <div>
                        <div className="font-medium text-foreground">Receber e-mail das solicitações <strong>Finalizadas</strong> Workflows</div>
                        <p className="text-sm text-muted-foreground">
                            Você receberá um e-mail quando uma solicitação criada por você for finalizada.
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {salvando && <i className="fa fa-spinner fa-spin text-muted-foreground text-xs" />}
                    <InputSwitch
                        checked={receberEmailFinalizada}
                        disabled={salvando}
                        onChange={e => alternar("receberEmailSolicitacaoFinalizada", receberEmailFinalizada, setReceberEmailFinalizada, e.value)}
                    />
                </div>
            </div>
                 <div className="flex items-center justify-between gap-4 p-4 border border-border rounded-lg">
                <div className="flex items-start gap-3">
                    <i className="fa fa-envelope text-primary mt-1" />
                    <div>
                        <div className="font-medium text-foreground">Receber e-mail diariamente sobre tarefas atrasadas</div>
                        <p className="text-sm text-muted-foreground">
                            Você receberá um e-mail das pendências de solicitações que estão com você ou com seu grupo.
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {salvando && <i className="fa fa-spinner fa-spin text-muted-foreground text-xs" />}
                    <InputSwitch
                        checked={receberEmailAtrasadas}
                        disabled={salvando}
                        onChange={e => alternar("receberEmailSolicitacaoAtrasadas", receberEmailAtrasadas, setReceberEmailAtrasadas, e.value)}
                    />
                </div>
            </div>
                 <div className="flex items-center justify-between gap-4 p-4 border border-border rounded-lg">
                <div className="flex items-start gap-3">
                    <i className="fa fa-envelope text-primary mt-1" />
                    <div>
                        <div className="font-medium text-foreground">Receber e-mail de novas tarefas atríbuidas</div>
                        <p className="text-sm text-muted-foreground">
                            Você receberá um e-mail quando uma solicitação chegar diretamente para você ou seu grupo.
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {salvando && <i className="fa fa-spinner fa-spin text-muted-foreground text-xs" />}
                    <InputSwitch
                        checked={receberEmailNovaSolicitacao}
                        disabled={salvando}
                        onChange={e => alternar("receberEmailNovaSolicitacao", receberEmailNovaSolicitacao, setReceberEmailNovaSolicitacao, e.value)}
                    />
                </div>
            </div>
        </div>
    );
}
